__turbopack_context__.v({
  "container": "wMQiVW_container",
  "image": "wMQiVW_image",
});
